import React from "react";
import AppLayout from "../components-app/AppLayout";
import OverviewList from "../components-static/OverviewList";
import {
  PageMenu,
  DeleteListItem,
  GenerateSpreadsheet,
  AddListItem,
  MobileMenu,
  Dropzone,
  LoadGraphic,
  Step,
  SegmentComplete,
} from "../components-static/Common";
import {
  EditSizeLabel,
  EmptyBox,
  EditableBox,
  EditableDate,
  EditableTime,
  EditableSelect,
  Box,
  Select,
  Time,
  Date,
  TextButton,
  Button,
  MiniPlusButton,
  MiniMinusButton,
  Checkbox,
} from "../components-static/Input";
import u from "../utilities/Utilities";
import { AppointmentPurpose } from "../data/Options";
import PropTypes from "prop-types";
import { Spreadsheet } from "../data/Mimetypes";
import "../styles/staff-list.scss";
import "../styles/appointment-list.scss";
import store from "store";
import moment from "moment";

export default class AppointmentList extends React.Component {
  state = {
    selected: {
      tags: [],
      all: false,
      data: [],
      entryCount: 0,
    },
    pageMenuButtons: [],
    spreadsheetOptions: [],
    addError: "",
    permissions: {},
    selectMode: false,
    visitorAutocomplete: [],
  };

  pageData = {
    title: "Appointments",
    permission: "appointments",
    url: "/appointment-list",
    scrollAnchor: u.getKey(),
  };

  listData = {
    deleteURL: "/api/delete-appointment-entries",
    spreadsheetURL: "/api/generate-appointment-spreadsheet",
    overviewURL: "/api/get-all-appointment",
    bulkTemplate: "/api/get-add-visitor-template",
    overviewLabel: "appointment-list",
    orderByField: "date",
    orderByType: "descending",
    numRows: 20,
    checkboxPermissions: {},
    listOptions: [
      { label: "Tag Setting", ref: "macro", enabled: true, type: "list" },
    ],
  };

  componentDidMount = () => {
    this.getVisitorAutocomplete();
    const permissions = u.getPermissions("appointments");
    this.setState({
      permissions: permissions,
      pageMenuButtons: [
        {
          label: "Add",
          mobileLabel: "Add Appointment",
          ref: "add",
          image: "/images/page-menu/add.png",
          title: "Add new appointment",
          enabled: permissions.create == 2,
        },
        {
          label: "Template",
          mobileLabel: "Download Template",
          ref: "download",
          image: "/images/page-menu/template.png",
          title: "Download bulk add template",
          enabled: permissions.create == 2,
          onClick: this.onDownloadTemplate,
        },
        {
          label: "Delete",
          mobileLabel: "Delete Appointment",
          ref: "delete",
          image: "/images/page-menu/delete.png",
          title: "Delete selected appointment",
          enabled: permissions.delete == 2,
        },
        {
          label: "Spreadsheet",
          mobileLabel: "Generate Spreadsheet",
          ref: "spreadsheet",
          image: "/images/page-menu/spreadsheet.png",
          title: "Generate spreadsheet from selection",
          enabled: true,
        },
      ],
    });
  };

  onMenuOptionClicked = (ref, show, mobileNav) => {
    if (mobileNav) {
      const toggle = this.mobileSelect != ref;
      this.setState({
        selectMode: (ref == "spreadsheet" || ref == "delete") && toggle,
      });
      this.mobileSelect = toggle ? ref : null;
      for (var i = 0; i < mobileNav.length; i++) {
        const r = mobileNav[i].ref;
        const show = r == ref;

        if (show) {
          if (mobileNav[i].onClick) {
            mobileNav[i].onClick();
          } else if (mobileNav[i].type == "list") {
            this.refs["overview"].triggerListOptions(r, toggle);
          } else {
            this.refs[r].show(toggle);
          }
        } else {
          if (mobileNav[i].onClick) {
          } else if (mobileNav[i].type == "list") {
            this.refs["overview"].triggerListOptions(r, false);
          } else {
            this.refs[r].show(false);
          }
        }
      }
    } else {
      this.setState({
        selectMode: (ref == "spreadsheet" || ref == "delete") && show,
      });
      this.refs[ref].show(show);
    }
  };

  onToggleForm = (ref, show) => {
    this.refs["menu"].toggleForm(ref, show);
    this.mobileSelect = show ? ref : null;
  };

  onSelectChange = (selected) => {
    this.setState({ selected: selected });
  };

  onRefreshList = () => {
    this.refs["overview"].onRefreshList();
  };

  onContentGrabbed = (content) => {
    this.setState({ spreadsheetOptions: content.spreadsheetOptions });
  };

  onDownloadTemplate = () => {
    u.post({
      url: this.listData.bulkTemplate,
      data: {},
      success: (callback) => {
        u.download(
          callback.filename,
          callback.filestamp,
          () => {},
          (error, status) => {
            this.setState({ error: error });
          }
        );
      },
      error: (error, status) => {
        this.setState({ error: error });
      },
    });
  };

  getVisitorAutocomplete = () => {
    u.post({
      url: "/api/get-visitor-autocomplete",
      data: {},
      success: (visitorAutocomplete) => {
        this.setState({ visitorAutocomplete: visitorAutocomplete });
      },
      error: (error) => {
        this.setState({ error: error });
      },
    });
  };

  findEntry = (appointmentID) => {
    this.refs["overview"].onForceTags(["@id(" + appointmentID + ")"]);
  };

  render = () => {
    const mobileMenu = this.state.pageMenuButtons.concat(
      this.listData.listOptions
    );
    return (
      <AppLayout
        title={this.pageData.title}
        requiredPermission={this.pageData.permission}
        url={this.pageData.url}
      >
        <div className="page-error">{this.state.error}</div>
        <PageMenu
          id={this.pageData.scrollAnchor}
          title={this.pageData.title}
          ref="menu"
          buttons={this.state.pageMenuButtons}
          onMenuOptionClicked={this.onMenuOptionClicked}
        >
          <AddEntry
            scrollAnchor={this.pageData.scrollAnchor}
            ref="add"
            reference="add"
            onToggleForm={this.onToggleForm}
            onRefreshList={this.onRefreshList}
            visitorAutocomplete={this.state.visitorAutocomplete}
            onViewEntry={this.findEntry}
          />
          <DeleteListItem
            scrollAnchor={this.pageData.scrollAnchor}
            ref="delete"
            reference="delete"
            url={this.listData.deleteURL}
            selected={this.state.selected}
            onToggleForm={this.onToggleForm}
            onRefreshList={this.onRefreshList}
          />
          <GenerateSpreadsheet
            scrollAnchor={this.pageData.scrollAnchor}
            ref="spreadsheet"
            url={this.listData.spreadsheetURL}
            options={this.state.spreadsheetOptions}
            reference="spreadsheet"
            selected={this.state.selected}
            onToggleForm={this.onToggleForm}
          />
        </PageMenu>
        <OverviewList
          ref="overview"
          selectMode={this.state.selectMode}
          url={this.listData.overviewURL}
          label={this.listData.overviewLabel}
          numRows={this.listData.numRows}
          orderByField={this.listData.orderByField}
          orderByType={this.listData.orderByType}
          onSelectChange={this.onSelectChange}
          registerReference={this.registerReference}
          onContentGrabbed={this.onContentGrabbed}
          onMutatedChange={this.onMutatedChange}
          checkboxPermissions={this.listData.checkboxPermissions}
        >
          {(content, index, onChange, onContentChange, registerRef) => {
            return (
              <AppointmentItem
                key={index}
                index={index}
                content={content}
                onChange={onChange}
                onContentChange={onContentChange}
                registerReference={registerRef}
                permissions={this.state.permissions}
                visitorAutocomplete={this.state.visitorAutocomplete}
              />
            );
          }}
        </OverviewList>
        <MobileMenu content={mobileMenu} onClick={this.onMenuOptionClicked} />
      </AppLayout>
    );
  };
}

class AppointmentItem extends React.Component {
  state = {
    error: "",
    loading: false,
    loadText: "Preparing",
    entryData: {},
    step: "view",
    showVisitors: false,
  };

  onAddVisitor = () => {
    this.setState({ error: "" });
    const inputs = ["visitorName", "email", "contactNumber"];
    for (var i = 0; i < inputs.length; i++) {
      const current = this.refs[inputs[i]].validate();
      if (!current.valid) {
        this.setState({ error: current.value });
        return 0;
      }
    }
    this.setState({ loading: true, loadText: "Creating visitor..." });
    const entryData = this.state.entryData;

    u.post({
      url: "/api/add-visitor",
      data: {
        tenantID: this.props.content.tenantID,
        tenantName: this.props.content.tenantName,
        visitorName: entryData.visitorName,
        email: entryData.email,
        contactNumber: entryData.contactNumber,
      },
      success: (visitorID) => {
        let visitor = Object.assign({}, entryData);
        visitor.visitorID = visitorID;
        this.setState({ entryData: {} });
        this.onVisitorAdded(visitor);
      },
      error: (error) => {
        this.setState({ error: error, loading: false });
      },
    });
  };

  onVisitorAdded = (visitor) => {
    u.post({
      url: "/api/appointment-add-visitor",
      data: {
        appointmentID: this.props.content.appointmentID,
        tenantID: this.props.content.tenantID,
        tenantName: this.props.content.tenantName,
        visitor: visitor,
      },
      success: (newVisitor) => {
        let visitors = this.props.content.visitors;
        visitors = newVisitor;
        this.props.onChange(newVisitor, "visitors", this.props.index);
        this.setState({ loading: false, step: "view", entryData: {} });
      },
      error: (error) => {
        this.setState({ error: error, loading: false });
      },
    });
  };

  onCheckVisitor = () => {
    this.setState({ error: "" });
    const email = this.refs["email"].validate();
    if (!email.valid) {
      this.setState({ error: email.value });
      return 0;
    }
    const visitorList = this.props.content.visitors;
    for (var v = 0; v < visitorList.length; v++) {
      if (visitorList[v].email == email.value) {
        this.setState({
          error: "Guest with this email has already been added to this entry",
        });
        return 0;
      }
    }

    this.setState({ loading: true, loadText: "Checking visitor email..." });
    u.post({
      url: "/api/check-visitor",
      data: {
        tenantID: this.props.content.tenantID,
        email: email.value,
      },
      success: ({ exist, visitor }) => {
        if (exist) {
          this.onVisitorAdded(visitor);
        } else {
          let entryData = this.state.entryData;
          entryData.email = email.value;
          this.setState({
            entryData: entryData,
            step: "add-new",
            loading: false,
          });
        }
      },
      error: (error) => {
        this.setState({ error: error });
      },
    });
  };

  onRemoveVisitor = () => {
    this.setState({ loading: true, loadText: "Removing visitor..." });
    u.post({
      url: "/api/appointment-remove-visitor",
      data: {
        appointmentID: this.props.content.appointmentID,
        tenantID: this.props.content.tenantID,
        visitor: this.props.content.visitors[this.state.removeIndex],
      },
      success: () => {
        const removeIndex = this.state.removeIndex;
        let visitors = this.props.content.visitors;
        visitors.splice(removeIndex, 1);
        this.props.onChange(visitors, "visitors", this.props.index);
        this.setState({ step: "view", loading: false });
      },
      error: (error) => {
        this.setState({ error: error, loading: false });
      },
    });
  };

  onChangeVisitor = (value, label, index, option) => {
    let visitors = this.props.content.visitors;
    visitors[index][label] = value;
    this.props.onChange(visitors, "visitors", this.props.index);
  };

  onChangeEntry = (value, label) => {
    let entryData = this.state.entryData;
    entryData[label] = value;
    this.setState({ entryData: entryData });
  };

  onPrint(index) {
    const visitor = this.props.content.visitors[index];
    store.set("access-card-token", visitor.token);
    window.open(
      "/access-card?action=print",
      "_blank",
      "width=800,height=800,left=200,top=100"
    );
  }

  onFileAdded = (filename) => {
    this.setState({ loading: true, loadText: "Uploading...", error: "" });
  };

  onFileUploaded = (filename) => {
    u.post({
      url: "/api/appointment-add-visitor",
      data: {
        appointmentID: this.props.content.appointmentID,
        tenantID: this.props.content.tenantID,
        tenantName: this.props.content.tenantName,
        filename: filename,
      },
      success: (newVisitor) => {
        let visitors = this.props.content.visitors;
        visitors = newVisitor;
        this.props.onChange(newVisitor, "visitors", this.props.index);
        this.setState({ loading: false, step: "view", entryData: {} });
      },
      error: (error) => {
        this.setState({ error: error, loading: false });
      },
    });
  };

  onFileError = (error) => {
    this.setState({ loading: false, error: error });
  };

  onFileProgress = (progress) => {
    this.setState({ loadText: "Uploading..." + progress + "%", error: "" });
  };

  onChangeDate = (value, label, index) => {
    this.props.onChange(value, label, index);

    let content = this.props.content;

    if (label == "startDate") {
      const start = value + "T" + content.startTime;
      this.props.onChange(start, "start", this.props.index);
    } else if (label == "startTime") {
      const start = content.startDate + "T" + value;
      this.props.onChange(start, "start", this.props.index);
    } else if (label == "endDate") {
      const end = value + "T" + content.endTime;
      this.props.onChange(end, "end", this.props.index);
    } else if (label == "endTime") {
      const end = content.endDate + "T" + value;
      this.props.onChange(end, "end", this.props.index);
    }
  };

  render = () => {
    const content = this.props.content;
    const edit = this.props.permissions.update == 2;
    const url = "/api/update-appointment-info";
    const index = this.props.index + "";
    const id = content.appointmentID;
    const entryData = this.state.entryData;

    return (
      <div style={{ textAlign: "center" }}>
        <LoadGraphic
          active={this.state.loading}
          text={this.state.loadText}
          style={{ fontSize: "1.25em" }}
        />

        <Step active={this.state.step == "view"}>
          <div>
            <div
              className="list-segment extended"
              style={{ textAlign: "left" }}
            >
              <div className="list-segment-item">
                <div className="list-segment-label">Tenant:</div>
                <div className="list-segment-input">
                  <EditSizeLabel>{content.tenantName}</EditSizeLabel>
                </div>
              </div>
              <div className="list-segment-item">
                <div className="list-segment-label">Unit:</div>
                <div className="list-segment-input">
                  <EditSizeLabel>
                    {content.tenantBlock}, {content.tenantUnit}
                  </EditSizeLabel>
                </div>
              </div>
              <div className="list-segment-item">
                <div className="list-segment-label">Invited By:</div>
                <div className="list-segment-input">
                  <EditSizeLabel>{content.staffName}</EditSizeLabel>
                </div>
              </div>
              <div className="list-segment-item">
                <div className="list-segment-label">Purpose:</div>
                <div className="list-segment-input">
                  <EditableSelect
                    label="Purpose"
                    field="purpose"
                    values={{
                      value: content.purpose,
                      enabled: edit,
                      options: AppointmentPurpose,
                    }}
                    index={index}
                    id={id}
                    url={url}
                    onChange={this.props.onChange}
                  />
                </div>
              </div>
	      <div className="list-segment-item">
                <div className="list-segment-label">Created On:</div>
                <div className="list-segment-input">
                  <EditSizeLabel nullText="None">
                    {moment(content.createdOn).format('DD MMM YYYY')}
                  </EditSizeLabel>
                </div>
              </div>
            </div>

            <div
              className="list-segment extended"
              style={{ textAlign: "left" }}
            >
              <div className="list-segment-item">
                <div className="list-segment-label">Start Date:</div>
                <div className="list-segment-input">
                  <EditableDate
                    label="Start Date"
                    field="startDate"
                    values={{ value: content.startDate, enabled: edit }}
                    range={[1, 2]}
                    rules={{
                      nullText: "None",
                      minDate: moment().format("YYYY-MM-DD"),
                    }}
                    index={index}
                    id={id}
                    url={url}
                    onChange={this.onChangeDate}
                  />
                </div>
              </div>
              <div className="list-segment-item">
                <div className="list-segment-label">Start Time:</div>
                <div className="list-segment-input">
                  <EditableTime
                    label="Start Time"
                    field="startTime"
                    values={{ value: content.startTime, enabled: edit }}
                    rules={{
                      required: true,
                      nullText: "None",
                      skipSeconds: true,
                    }}
                    index={index}
                    id={id}
                    url={url}
                    onChange={this.onChangeDate}
                  />
                </div>
              </div>
              <div className="list-segment-item">
                <div className="list-segment-label">End Date:</div>
                <div className="list-segment-input">
                  <EditableDate
                    label="End Date"
                    field="endDate"
                    values={{ value: content.endDate, enabled: edit }}
                    range={[1, 2]}
                    rules={{ nullText: "None", minDate: content.startDate }}
                    index={index}
                    id={id}
                    url={url}
                    onChange={this.onChangeDate}
                  />
                </div>
              </div>
              <div className="list-segment-item">
                <div className="list-segment-label">End Time:</div>
                <div className="list-segment-input">
                  <EditableTime
                    label="End Time"
                    field="endTime"
                    values={{ value: content.endTime, enabled: edit }}
                    rules={{
                      required: true,
                      nullText: "None",
                      skipSeconds: true,
                    }}
                    index={index}
                    id={id}
                    url={url}
                    onChange={this.onChangeDate}
                  />
                </div>
              </div>
            </div>

            {this.state.showVisitors ? (
              <div className="list-segment-table short">
                {content.visitors.length > 0 ? (
                  <div>
                    <h2 style={{ display: "inline-block" }}>
                      Visitors ({content.visitors.length} pax)
                    </h2>
                    <div style={{ maxHeight: "250px", overflow: "auto" }}>
                      <table className="visitor-table">
                        <tbody>
                          <tr>
                            <th className="visitor-remove" />
                            <th className="visitor-sn">S/N</th>
                            <th className="visitor-name">Name</th>
                            <th className="visitor-email">Email</th>
                            <th className="visitor-number">Mobile Number</th>
                            <th className="visitor-company">Company Name</th>
			    <th className="visitor-company">Registered On</th>
                            <th className="visitor-print mobile-hide" />
                          </tr>
                          {content.visitors.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td className="visitor-remove">
                                  <div
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      margin: "auto",
                                    }}
                                  >
                                    <MiniMinusButton
                                      index={index + ""}
                                      onClick={() => {
                                        this.setState({
                                          step: "remove",
                                          removeIndex: index,
                                          removeName:
                                            this.props.content.visitors[index]
                                              .visitorName,
                                        });
                                      }}
                                    />
                                  </div>
                                </td>
                                <td className="visitor-sn">{index + 1}</td>
                                <td className="visitor-name">
                                  <EditableBox
                                    label="Visitor Name"
                                    field="visitorName"
                                    index={index + ""}
                                    values={{ value: item.visitorName }}
                                    rules={{ required: true }}
                                    url="/api/update-visitor-info"
                                    id={item.visitorID}
                                    onChange={this.onChangeVisitor}
                                  />
                                </td>
                                <td className="visitor-email">
                                  <EditableBox
                                    label="Email"
                                    field="email"
                                    index={index + ""}
                                    values={{
                                      value: item.email,
                                      enabled: false,
                                    }}
                                    rules={{ required: true }}
                                    type="email"
                                    url="/api/update-visitor-info"
                                    id={item.visitorID}
                                    onChange={this.onChangeVisitor}
                                  />
                                </td>
                                <td className="visitor-number">
                                  <EditableBox
                                    label="Mobile Number"
                                    field="contactNumber"
                                    index={index + ""}
                                    values={{ value: item.contactNumber }}
                                    rules={{ required: true }}
                                    url="/api/update-visitor-info"
                                    id={item.visitorID}
                                    onChange={this.onChangeVisitor}
                                  />
                                </td>
                                <td className="visitor-company">
                                  <EditableBox
                                    label="Company Name"
                                    field="companyName"
                                    index={index + ""}
                                    values={{ value: item.companyName }}
                                    rules={{ required: true, nullText: "None" }}
                                    url="/api/update-visitor-info"
                                    id={item.visitorID}
                                    onChange={this.onChangeVisitor}
                                  />
                                </td>
				<td className="visitor-last-updated-datetime">
                                  <EditableBox
                                    label="Registered On"
                                    field="lastUpdatedDateTime"
                                    index={index + ""}
                                    values={{ value: item.lastUpdatedDateTime }}
                                    rules={{ required: true, nullText: "None" }}
                                    url="/api/update-visitor-info"
                                    id={item.visitorID}
                                    onChange={this.onChangeVisitor}
                                  />
                                </td>
                                <td
                                  className="visitor-print mobile-hide"
                                  title="Print Access Card"
                                >
                                  <div
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      margin: "auto",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      this.onPrint(index);
                                    }}
                                  >
                                    <img src="/images/cards/print-card.png" />
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="list-segment-placeholder">
                    <div style={{ margin: "20px auto" }}>
                      <b>No Visitors Added</b>
                    </div>
                  </div>
                )}
              </div>
            ) : null}

            <div className="list-segment-buttons">
              <TextButton
                onClick={() => {
                  this.setState({ showVisitors: !this.state.showVisitors });
                }}
              >
                {!this.state.showVisitors ? "Show Visitors" : "Hide Visitors"}
              </TextButton>
              {this.state.showVisitors ? (
                <TextButton
                  onClick={() => {
                    this.setState({ step: "add-check" });
                  }}
                >
                  Add Visitor
                </TextButton>
              ) : null}
            </div>
          </div>
        </Step>

        <Step active={this.state.step == "add-check"}>
          <div>
            <h2>Please complete the following to continue</h2>
            <div style={{ margin: "35px auto 20px 0" }}>
              <div className="segment-full-item list" style={{ zIndex: 3 }}>
                <div className="segment-item-label">Visitor Email:</div>
                <div className="segment-item-input">
                  <Box
                    ref="email"
                    label="Email"
                    field="email"
                    type="email"
                    rules={{
                      required: true,
                      list: this.props.visitorAutocomplete,
                      listHeight: "120px",
                    }}
                  />
                </div>
              </div>
              <div>
                <TextButton
                  onClick={() => {
                    this.setState({ error: "", step: "add-bulk" });
                  }}
                >
                  Add Bulk Visitors
                </TextButton>
              </div>
            </div>

            <div className="segment-margin-area bold" style={{ zIndex: 2 }}>
              <b>
                An email with the appointment details and turnstile access QR
                code will be sent to the visitor upon completion
              </b>
            </div>

            <div className="segment-buttons" style={{ zIndex: 1 }}>
              <div className="list-segment-error">{this.state.error}</div>
              <Button
                type="medium"
                onClick={() => {
                  this.setState({ step: "view" });
                }}
              >
                Back
              </Button>
              <Button type="medium" onClick={this.onCheckVisitor}>
                Add
              </Button>
            </div>
          </div>
        </Step>

        <Step active={this.state.step == "add-new"}>
          <div>
            <h2>Please complete the following to continue</h2>

            <div style={{ margin: "35px auto" }}>
              <div className="segment-full-item list">
                <div className="segment-item-label">Visitor Name:</div>
                <div className="segment-item-input">
                  <Box
                    ref="visitorName"
                    label="Visitor Name"
                    field="visitorName"
                    values={{ value: entryData.visitorName }}
                    rules={{ required: true }}
                    onChange={this.onChangeEntry}
                  />
                </div>
              </div>

              <div className="segment-full-item list">
                <div className="segment-item-label">Email:</div>
                <div className="segment-item-input">
                  <Box
                    ref="email"
                    label="Email"
                    field="email"
                    type="email"
                    values={{ value: entryData.email }}
                    rules={{ required: true }}
                    onChange={this.onChangeEntry}
                  />
                </div>
              </div>

              <div className="segment-full-item list">
                <div className="segment-item-label">Contact Number:</div>
                <div className="segment-item-input">
                  <Box
                    ref="contactNumber"
                    label="Contact Number"
                    field="contactNumber"
                    values={{ value: entryData.contactNumber }}
                    rules={{ required: true, mobileNumber: true }}
                    onChange={this.onChangeEntry}
                  />
                </div>
              </div>
            </div>

            <div className="segment-margin-area bold">
              <b>
                An email with the appointment details and turnstile access QR
                code will be sent to the visitor upon completion
              </b>
            </div>

            <div className="segment-buttons">
              <div className="list-segment-error">{this.state.error}</div>
              <Button
                type="medium"
                onClick={() => {
                  this.setState({ step: "add-check" });
                }}
              >
                Back
              </Button>
              <Button type="medium" onClick={this.onAddVisitor}>
                Confirm
              </Button>
            </div>
          </div>
        </Step>

        <Step active={this.state.step == "add-bulk"}>
          <div>
            <div style={{ fontSize: "1.25em" }}>
              <Dropzone
                accessibleForPreview={false}
                onAdded={this.onFileAdded}
                onUploaded={this.onFileUploaded}
                onError={this.onFileError}
                onProgress={this.onFileProgress}
                filetypes={Spreadsheet}
                label={"dropzone-" + this.props.index}
              />
            </div>
            <div className="segment-buttons">
              <div className="list-segment-error">{this.state.error}</div>
              <Button
                type="medium"
                onClick={() => {
                  this.setState({ step: "view" });
                }}
              >
                Back
              </Button>
            </div>
          </div>
        </Step>

        <Step active={this.state.step == "remove"}>
          <div>
            <h2 style={{ padding: "30px 0 0 0" }}>
              Remove{" "}
              <span className="text-negative">{this.state.removeName}</span>{" "}
              from this appointment?
            </h2>
            <div style={{ padding: "10px 0 20px 0" }}>
              Guest will receive a cancellation email and access pass will be
              invalidated
            </div>
            <div className="list-segment-buttons">
              <Button
                type="medium"
                onClick={() => {
                  this.setState({ step: "view" });
                }}
              >
                Back
              </Button>
              <Button type="medium" onClick={this.onRemoveVisitor}>
                Confirm
              </Button>
            </div>
          </div>
        </Step>
      </div>
    );
  };
}

class AddEntry extends React.Component {
  state = {
    error: "",
    step: "add-visitor",
    entryData: {
      startDate: moment().format("YYYY-MM-DD"),
      startTime: "00:00:00",
      endDate: moment().format("YYYY-MM-DD"),
      endTime: "23:59:59",
      visitors: [],
    },
    visitorData: {},
    tenantOptions: [],
    loading: false,
    loadText: "",
    print: u.getSuperUser(),
    appointment: {},
    cargoLiftOptions: [],
    superUser: false,
    durational: false,
  };

  addData = {
    addType: 0,
    addURL: "/api/add-appointment",
  };

  show = (show) => {
    this.refs[this.props.reference].show(show);
  };

  componentDidMount = () => {
    this.getTenantOptions();

    if (u.getSuperUser()) {
      this.getCargoLiftOptions();
      this.setState({ superUser: true });
    }
  };

  getTenantOptions = () => {
    u.post({
      url: "/api/get-tenant-options",
      data: {},
      success: (tenantOptions) => {
        if (tenantOptions.length > 0) {
          let entryData = this.state.entryData;
          entryData.tenantID = tenantOptions[0].value;
          entryData.tenantName = tenantOptions[0].label;
          entryData.tenantBlock = tenantOptions[0].block;
          entryData.tenantUnit = tenantOptions[0].unit;
          this.setState({ entryData: entryData });
        }
        this.setState({ tenantOptions: tenantOptions });
      },
      error: (error) => {
        this.setState({ error: error });
      },
    });
  };

  onChangeEntry = (value, label, index, option) => {
    let entryData = this.state.entryData;
    if (label == "tenantID") {
      entryData.tenantName = option.label;
    }
    entryData[label] = value;
    this.setState({ entryData: entryData });
  };

  findVisitor = () => {
    this.setState({ error: "" });
    const email = this.refs["email"].validate();
    if (!email.valid) {
      this.setState({ error: email.value });
      return 0;
    }
    let entryData = this.state.entryData;
    entryData.visitors = [];

    u.post({
      url: "/api/check-visitor",
      data: {
        tenantID: this.state.entryData.tenantID,
        email: email.value,
      },
      success: ({ exist, visitor, hasAppointment, appointment }) => {
        console.log(exist, visitor, hasAppointment, appointment);
        if (hasAppointment) {
          //Link to appointment entry
          this.setState({
            step: "appointment-exists",
            visitorData: visitor,
            loading: false,
            appointment: appointment,
          });
        } else {
          if (exist) {
            //go to confirm
            entryData.visitors = [visitor];
            this.setState({
              entryData: entryData,
              visitorData: visitor,
              step: "details",
              loading: false,
              date: moment().format("YYYY-MM-DD"),
              start: moment().format("HH:mm:ss"),
            });
          } else {
            //add more details
            let visitorData = this.state.visitorData;
            visitorData.email = email.value;
            this.setState({
              visitorData: visitorData,
              loading: false,
              step: "add-new-visitor",
              entryData: entryData,
            });
          }
        }
      },
      error: (error) => {
        this.setState({ error: error });
      },
    });
  };

  onChangeNewVisitor = (value, label) => {
    let visitorData = this.state.visitorData;
    visitorData[label] = value;
    this.setState({ visitorData: visitorData });
  };

  onAddBulk = () => {
    this.refs[this.props.reference].onBulkUpload();
  };

  onFileUploaded = (filename, userfilename) => {
    let entryData = this.state.entryData;
    entryData.filename = filename;
    this.setState({
      entryData: entryData,
      userfilename: userfilename,
      print: false,
      step: "details",
      error: "",
    });
  };

  onAddNewVisitor = () => {
    this.setState({ error: "" });
    const inputs = ["visitorName", "email", "contactNumber"];
    for (var i = 0; i < inputs.length; i++) {
      const current = this.refs[inputs[i]].validate();
      if (!current.valid) {
        this.setState({ error: current.value });
        return 0;
      }
    }

    let visitor = Object.assign({}, this.state.visitorData);
    visitor.tenantID = this.state.entryData.tenantID;
    visitor.tenantName = this.state.entryData.tenantName;

    let entryData = this.state.entryData;
    entryData.visitors.push(visitor);
    this.setState({
      error: "",
      entryData: entryData,
      step: "details",
      date: moment().format("YYYY-MM-DD"),
      start: moment().format("HH:mm:ss"),
      end: moment().add(2, "hours").format("HH:mm:ss"),
    });
  };

  onCheckEntry = () => {
    this.setState({ error: "" });
    const inputs = [
      "tenantID",
      "purpose",
      "startDate",
      "startTime",
      "endDate",
      "endTime",
    ];
    for (var i = 0; i < inputs.length; i++) {
      if (this.refs[inputs[i]]) {
        const current = this.refs[inputs[i]].validate();
        if (!current.valid) {
          this.setState({ error: current.value });
          return 0;
        }
      }
    }

    let entryData = this.state.entryData;
    if (this.state.durational) {
      const start = entryData.startDate + "T" + entryData.startTime;
      const end = entryData.endDate + "T" + entryData.endTime;
      if (moment(start).isAfter(end, "second")) {
        this.setState({
          error: "End date/time cannot be before Start date/time",
        });
        return 0;
      } else {
        entryData.start = start;
        entryData.end = end;
        this.setState({ step: "review", entryData: entryData });
      }
    } else {
      entryData.startTime = "00:00:00";
      entryData.endDate = entryData.startDate;
      entryData.endTime = "23:59:59";
      entryData.start = entryData.startDate + "T00:00:00";
      entryData.end = entryData.startDate + "T23:59:59";
      this.setState({ step: "review", entryData: entryData });
    }
  };

  onAddEntry = () => {
    this.setState({ loading: true, loadText: "Creating appointment..." });
    let entryData = this.state.entryData;

    console.log(entryData);

    if (entryData.cargoLift) {
      entryData.cargoLiftFloors = this.state.cargoLiftOptions.map((block) => {
        const floors = block.options
          .filter((option) => {
            return option.selected;
          })
          .map((option) => {
            return option.value;
          });
        return { block: block.block, floors: floors };
      });
    }

    u.post({
      url: this.addData.addURL,
      data: {
        fields: entryData,
      },
      success: ({ appointment, bulkCount, visitor }) => {
        if (this.state.print) {
          this.onPrint(visitor);
        }
        this.setState({
          step: "complete",
          loading: false,
          appointment: appointment,
          bulkCount: bulkCount ? bulkCount : false,
        });
      },
      error: (error) => {
        this.setState({ error: error, loading: false });
      },
    });
  };

  onPrint(visitor) {
    //Open Print Voucher
    store.set("access-card-token", visitor.token);
    window.open(
      "/access-card?action=print",
      "_blank",
      "width=800,height=800,left=200,top=100"
    );
  }

  onComplete = () => {
    let tenantOptions = this.state.tenantOptions;

    this.setState({
      error: "",
      step: "add-visitor",
      entryData: {
        startDate: moment().format("YYYY-MM-DD"),
        startTime: "00:00:00",
        endDate: moment().format("YYYY-MM-DD"),
        endTime: "23:59:59",
        tenantID: tenantOptions[0].value,
        tenantName: tenantOptions[0].label,
        tenantBlock: tenantOptions[0].block,
        tenantUnit: tenantOptions[0].unit,
        visitors: [],
      },
      visitorData: {},
      print: u.getSuperUser(),
    });
  };

  onViewEntry = () => {
    this.props.onViewEntry(this.state.appointment.appointmentID);
  };

  getCargoLiftOptions = (tenantID) => {
    u.post({
      url: "/api/get-cargo-lift-options",
      data: {
        tenantID: tenantID,
      },
      success: (cargoLiftOptions) => {
        this.setState({ cargoLiftOptions: cargoLiftOptions });
      },
      error: (error) => {
        this.setState({ error: error });
      },
    });
  };

  onChangeCargo = (value, index, optionIndex) => {
    let cargoLiftOptions = this.state.cargoLiftOptions;
    cargoLiftOptions[index].options[optionIndex].selected = value;
    this.setState({ cargoLiftOptions: cargoLiftOptions });
  };

  onSelectAll = (index) => {
    let cargoLiftOptions = this.state.cargoLiftOptions;
    const select = !cargoLiftOptions[index].selected;
    for (var i = 0; i < cargoLiftOptions[index].options.length; i++) {
      cargoLiftOptions[index].options[i].selected = select;
    }
    cargoLiftOptions[index].selected = select;
    this.setState({ cargoLiftOptions: cargoLiftOptions });
  };

  onChangeDurational = () => {
    let current = this.state.durational;
    if (!current) {
      let entryData = this.state.entryData;
      entryData.endDate = entryData.startDate;
      entryData.startTime = "00:00:00";
      entryData.endTime = "23:59:59";
      this.setState({ entryData: entryData });
    }
    this.setState({ durational: !current });
  };

  hasEmail = (visitorData) => {
    if (visitorData.email) {
      return visitorData.email.length > 0;
    }
    return false;
  };

  render = () => {
    const content = this.state.entryData;
    const visitorData = this.state.visitorData;

    return (
      <AddListItem
        scrollAnchor={this.props.scrollAnchor}
        ref={this.props.reference}
        reference={this.props.reference}
        addType={this.addData.addType}
        index={this.addData.addIndex}
        label={this.addData.label}
        bulkURL={this.addData.bulkAddURL}
        filetypes={Spreadsheet}
        url={this.addData.addURL}
        onToggleForm={this.props.onToggleForm}
        onRefreshList={this.props.onRefreshList}
        onComplete={this.onComplete}
        onUploadBypass={this.onFileUploaded}
      >
        <div>
          <LoadGraphic active={this.state.loading} text={this.state.loadText} />

          <Step active={this.state.step == "add-visitor"}>
            <div>
              <h3>Please complete the following to continue</h3>
              <div
                style={{
                  position: "relative",
                  margin: "35px auto 20px auto",
                  zIndex: "3",
                }}
              >
                <div className="segment-full-item">
                  <div className="segment-item-label">Visitor Email:</div>
                  <div className="segment-item-input">
                    <Box
                      ref="email"
                      label="Vistor Email"
                      field="email"
                      type="email"
                      values={{ value: content.email }}
                      rules={{
                        required: !u.getSuperUser(),
                        list: this.props.visitorAutocomplete,
                        listHeight: "150px",
                      }}
                    />
                  </div>
                </div>
                <div style={{ fontSize: "0.9em" }}>
                  <TextButton onClick={this.onAddBulk}>
                    Upload Bulk Visitors
                  </TextButton>
                </div>
              </div>

              <div className="segment-margin-area" style={{ zIndex: 2 }}>
                An email with the appointment details and turnstile access QR
                code will be sent to the visitor upon completion
              </div>
              <div className="segment-buttons" style={{ zIndex: 1 }}>
                <div className="segment-error">{this.state.error}</div>
                {u.isMobileDevice() ? (
                  <Button
                    type="medium"
                    onClick={() => {
                      this.props.onToggleForm(this.props.reference, false);
                    }}
                  >
                    Cancel
                  </Button>
                ) : (
                  ""
                )}
                <Button type="medium" onClick={this.findVisitor}>
                  Next
                </Button>
              </div>
            </div>
          </Step>

          <Step active={this.state.step == "add-new-visitor"}>
            <div>
              <h3>Complete the following to continue</h3>
              <div style={{ margin: "20px auto" }}>
                <div className="segment-full-item">
                  <div className="segment-item-label">Visitor Name:</div>
                  <div className="segment-item-input">
                    <Box
                      label="Visitor Name"
                      ref="visitorName"
                      field="visitorName"
                      values={{ value: visitorData.visitorName }}
                      rules={{ required: true }}
                      onChange={this.onChangeNewVisitor}
                    />
                  </div>
                </div>
                <div className="segment-full-item">
                  <div className="segment-item-label">Email:</div>
                  <div className="segment-item-input">
                    <Box
                      label="Email"
                      ref="email"
                      field="email"
                      values={{ value: visitorData.email }}
                      type="email"
                      onChange={this.onChangeNewVisitor}
                    />
                  </div>
                </div>
                <div className="segment-full-item">
                  <div className="segment-item-label">Contact Number:</div>
                  <div className="segment-item-input">
                    <Box
                      label="Contact Number"
                      ref="contactNumber"
                      field="contactNumber"
                      values={{ value: visitorData.contactNumber }}
                      rules={{ required: true, mobileNumber: true }}
                      onChange={this.onChangeNewVisitor}
                    />
                  </div>
                </div>
              </div>
              <div className="segment-buttons">
                <div className="segment-error">{this.state.error}</div>
                <Button
                  type="medium"
                  onClick={() => {
                    this.setState({
                      step: "add-visitor",
                      error: "",
                      visitorData: {},
                    });
                  }}
                >
                  Back
                </Button>
                <Button type="medium" onClick={this.onAddNewVisitor}>
                  Next
                </Button>
              </div>
            </div>
          </Step>

          <Step active={this.state.step == "details"}>
            <div style={{ textAlign: "center" }}>
              <h3>Complete the following to continue</h3>
              <div className="segment-error">{this.state.error}</div>

              <div className="segment-content">
                <div className="segment-margin-area">
                  <div className="segment-full-item">
                    <div className="segment-item-label">Tenant:</div>
                    <div className="segment-item-input">
                      <Select
                        ref="tenantID"
                        label="Tenant"
                        field="tenantID"
                        values={{
                          value: content.tenantID,
                          options: this.state.tenantOptions,
                        }}
                        onChange={this.onChangeEntry}
                      />
                    </div>
                  </div>
                  <div className="segment-full-item">
                    <div className="segment-item-label">Purpose:</div>
                    <div className="segment-item-input">
                      <Select
                        ref="purpose"
                        label="Purpose"
                        field="purpose"
                        values={{
                          value: content.purpose,
                          options: AppointmentPurpose,
                        }}
                        onChange={this.onChangeEntry}
                      />
                    </div>
                  </div>
                  <div className="segment-full-item">
                    <div className="segment-item-label">
                      {this.state.durational ? "Start" : ""} Date:
                    </div>
                    <div className="segment-item-input">
                      <Date
                        ref="startDate"
                        label={this.state.durational ? "Start Date" : "Date"}
                        field="startDate"
                        values={{ value: content.startDate }}
                        range={[1, 2]}
                        onChange={this.onChangeEntry}
                      />
                    </div>
                  </div>
                  {this.state.durational ? (
                    <div>
                      <div
                        className="segment-full-item"
                        style={{ marginTop: "0" }}
                      >
                        <div className="segment-item-label">Start Time:</div>
                        <div className="segment-item-input">
                          <Time
                            ref="startTime"
                            label="Start Time"
                            field="startTime"
                            values={{ value: content.startTime }}
                            rules={{ skipSeconds: true }}
                            onChange={this.onChangeEntry}
                          />
                        </div>
                      </div>
                      <div className="segment-full-item">
                        <div className="segment-item-label">End Date:</div>
                        <div className="segment-item-input">
                          <Date
                            ref="endDate"
                            label="End Date"
                            field="endDate"
                            values={{ value: content.endDate }}
                            range={[1, 2]}
                            rules={{ minDate: content.startDate }}
                            onChange={this.onChangeEntry}
                          />
                        </div>
                      </div>
                      <div className="segment-full-item">
                        <div className="segment-item-label">End Time:</div>
                        <div className="segment-item-input">
                          <Time
                            ref="endTime"
                            label="End Time"
                            field="endTime"
                            values={{ value: content.endTime }}
                            rules={{ skipSeconds: true }}
                            onChange={this.onChangeEntry}
                          />
                        </div>
                      </div>
                    </div>
                  ) : null}

                  <div
                    className="segment-full-item"
                    style={{ textAlign: "center" }}
                  >
                    <TextButton onClick={this.onChangeDurational}>
                      {this.state.durational ? "Hide" : "Show"} Duration Options
                    </TextButton>
                  </div>
                </div>

                {this.state.superUser ? (
                  <div className="segment-margin-area">
                    <div>
                      <span style={{ margin: "0 10px" }}>
                        <Checkbox
                          values={{ value: content.oneTimeOnly }}
                          label="oneTimeOnly"
                          onChange={this.onChangeEntry}
                          title="User can only enter once"
                        />{" "}
                        One Time Entry
                      </span>
                      <span style={{ margin: "0 10px" }}>
                        <Checkbox
                          values={{ value: content.cargoLift }}
                          label="cargoLift"
                          onChange={this.onChangeEntry}
                          title="User can access cargo lift"
                        />{" "}
                        Cargo Lift Access
                      </span>
                    </div>
                    {content.cargoLift ? (
                      <div
                        className="segment-full-item"
                        style={{ textAlign: "center", margin: "0 auto" }}
                      >
                        {this.state.cargoLiftOptions.map((item, index) => {
                          return (
                            <div
                              key={index}
                              style={{
                                margin: "15px auto",
                                textAlign: "center",
                              }}
                            >
                              <div>
                                <TextButton
                                  onClick={() => {
                                    this.onSelectAll(index);
                                  }}
                                >
                                  <span className="bold">{item.block}</span>
                                </TextButton>
                              </div>
                              <div
                                style={{
                                  display: "inline-block",
                                  margin: "10px auto",
                                }}
                              >
                                {item.options.map((option, oindex) => {
                                  return (
                                    <div
                                      key={oindex}
                                      className="cargo-lift-options"
                                    >
                                      <div>
                                        <Checkbox
                                          values={{ value: option.selected }}
                                          onChange={(value) => {
                                            this.onChangeCargo(
                                              value,
                                              index,
                                              oindex
                                            );
                                          }}
                                        />
                                      </div>
                                      <div>{option.label}</div>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ) : null}

                <div className="segment-margin-area">
                  <div className="segment-error">{this.state.error}</div>
                  <Button
                    type="medium"
                    onClick={() => {
                      this.setState({ step: "add-visitor", visitorData: {} });
                    }}
                  >
                    Back
                  </Button>
                  <Button type="medium" onClick={this.onCheckEntry}>
                    Next
                  </Button>
                </div>
              </div>
            </div>
          </Step>

          <Step active={this.state.step == "review"}>
            <div>
              <h3>Please review the following</h3>
              <div style={{ margin: "30px auto" }}>
                <div className="segment-full-item">
                  <div className="segment-item-label">Tenant:</div>
                  <div className="segment-item-input">
                    <EmptyBox style={{ padding: "5px" }}>
                      {content.tenantName}
                    </EmptyBox>
                  </div>
                </div>
                <div className="segment-full-item">
                  <div className="segment-item-label">Purpose:</div>
                  <div className="segment-item-input">
                    <EmptyBox style={{ padding: "5px" }}>
                      {content.purpose}
                    </EmptyBox>
                  </div>
                </div>
                <div className="segment-full-item">
                  <div className="segment-item-label">Date/Time:</div>
                  <div className="segment-item-input">
                    <EmptyBox style={{ padding: "5px" }}>
                      {moment(content.start).format("DD/MM/YY (h:mma)") +
                        " - " +
                        moment(content.end).format("DD/MM/YY (h:mma)")}
                    </EmptyBox>
                  </div>
                </div>
                {content.filename ? (
                  <div className="segment-full-item">
                    <div className="segment-item-label">File:</div>
                    <div className="segment-item-input">
                      <EmptyBox style={{ padding: "5px" }}>
                        {this.state.userfilename}
                      </EmptyBox>
                    </div>
                  </div>
                ) : null}
                {content.filename ? null : (
                  <div className="segment-full-item">
                    <div className="segment-item-label">Visitor:</div>
                    <div className="segment-item-input">
                      <EmptyBox style={{ padding: "5px" }}>
                        {this.state.visitorData.visitorName}
                      </EmptyBox>
                    </div>
                  </div>
                )}
                {content.filename ? null : (
                  <div className="segment-full-item">
                    <div className="segment-item-label">Email:</div>
                    <div className="segment-item-input">
                      <EmptyBox style={{ padding: "5px" }}>
                        {this.state.visitorData.email
                          ? this.state.visitorData.email
                          : "None"}
                      </EmptyBox>
                    </div>
                  </div>
                )}
                {content.filename ? null : (
                  <div className="segment-full-item">
                    <div className="segment-item-label">Contact Number:</div>
                    <div className="segment-item-input">
                      <EmptyBox style={{ padding: "5px" }}>
                        {this.state.visitorData.contactNumber}
                      </EmptyBox>
                    </div>
                  </div>
                )}
              </div>
              {content.filename || !u.getSuperUser() ? null : (
                <div className="segment-buttons">
                  <Checkbox
                    label="Print"
                    values={{
                      value: this.state.print,
                      enabled: this.hasEmail(visitorData),
                    }}
                    onChange={(value) => {
                      this.setState({ print: value });
                    }}
                  />{" "}
                  Print Turnstile Access Pass
                </div>
              )}
              <div className="segment-buttons">
                <div className="segment-error">{this.state.error}</div>
                <Button
                  type="medium"
                  onClick={() => {
                    this.setState({ step: "details" });
                  }}
                >
                  Back
                </Button>
                <Button type="medium" onClick={this.onAddEntry}>
                  Confirm
                </Button>
              </div>
            </div>
          </Step>

          <Step active={this.state.step == "complete"}>
            <div>
              <SegmentComplete>
                Successfully created {content.purpose}
                {this.state.bulkCount ? (
                  <span>
                    {" "}
                    with{" "}
                    <span className="text-emphasis">
                      {this.state.bulkCount}
                    </span>{" "}
                    visitor{parseInt(this.state.bulkCount) > 1 ? "s" : ""}
                  </span>
                ) : (
                  <span>
                    {" "}
                    with{" "}
                    {content.visitors.length > 0
                      ? content.visitors[0].visitorName
                      : ""}
                  </span>
                )}
              </SegmentComplete>
              <div className="segment-buttons">
                <Button type="medium" onClick={this.onViewEntry}>
                  View Entry
                </Button>
                <Button type="medium" onClick={this.onComplete}>
                  Complete
                </Button>
              </div>
            </div>
          </Step>

          <Step active={this.state.step == "appointment-exists"}>
            <div>
              <h3>
                <span className="text-emphasis">{visitorData.visitorName}</span>{" "}
                has an appointment at {this.state.appointment.tenantBlock},{" "}
                {this.state.appointment.tenantUnit}
              </h3>
              <div>
                Contact Person: {this.state.appointment.staffName} (
                {this.state.appointment.staffContactNumber})
              </div>
              <div className="segment-buttons">
                <Button
                  type="medium"
                  onClick={() => {
                    this.setState({ step: "add-visitor" });
                  }}
                >
                  Back
                </Button>
                <Button
                  type="medium"
                  onClick={() => {
                    this.onPrint(visitorData);
                  }}
                >
                  Print Access Pass
                </Button>
              </div>
            </div>
          </Step>
        </div>
      </AddListItem>
    );
  };
}
AddEntry.propTypes = {
  scrollAnchor: PropTypes.string,
  onToggleForm: PropTypes.func.isRequired,
  onRefreshList: PropTypes.func.isRequired,
  skipDetails: PropTypes.bool,
};
